import type { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";

export const isDataReady = (
  isLoading: boolean,
  isError: boolean,
  results: UseQueryResult[],
  queries: UseQueryOptions[]
) => !(isLoading || isError || !results || results.length < queries.length || queries.length < 1);
